<div class="">
	<h3 class="mb-4">Register (Step 1 of 5)</h3>
	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
		<div class="alert alert-danger" *ngIf="message">
			{{message}}
		</div>
		<input formControlName="username" name="username" type="hidden" class="form-control" id="floatingUsername" placeholder="username" [readOnly]="true">


		<div class="mb-5">
			<label for="input-otp" class="form-label">2FA Token</label>
			<br>
			<nz-input-otp id="input-otp" appAutoFocus [nzLength]="6" formControlName="otp" name="otp"></nz-input-otp>
		</div>
		<ng-container *ngIf="sentOtp">
			<ul>
				<ng-container *ngFor="let channel of sentOtp.availableChannels">
					<li *ngIf="channel == sentOtp.sentViaChannel">
						<a class="btn btn-link btn-sm" (click)="reSend(channel)">Resend {{channel}} OTP to: {{sentOtp.sentToLocation}}</a>
					</li>
					<li *ngIf="channel != sentOtp.sentViaChannel">
						<a class="btn btn-link btn-sm" (click)="reSend(channel)">Send an {{channel}} with your OTP.</a>
					</li>
				</ng-container>
			</ul>
		</ng-container>

		<div class="btn-group w-100">
			<button class="w-75 btn btn-primary" [disabled]="form.invalid" *ngIf="submitting == false">Enter OTP</button>
			<button class="w-75 btn btn-primary" [disabled]="true" *ngIf="submitting == true">
				<i nz-icon nzType="loading" nzTheme="outline"></i>
			</button>
		</div>
	</form>
</div>
